/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Table,
  Checkbox,
} from "semantic-ui-react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import MyCheckpoint from "../common/myCheckpoint";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import UpdateAxios from "../axiosComponent/update";
import * as yup from "yup";
import { translate } from "react-i18next";

const ModalEditRouteCheckpoint = ({
  values,
  onClose,
  open,
  handleSubmit,
  route_details,
  addAfter,
  setFieldValue,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
 
  useEffect(() => {
      if (open == true) {
        console.log("get all fetch", addAfter, route_details);
      }
  }, []);

  handleSubmit

  return (
    <div>
      <Modal onClose={onClose} open={open} size="mini">
        <Modal.Header className="p-bold-100">
          <span>{t("title") || "Vehicle Details"}</span>
        </Modal.Header>
        <Modal.Content scrolling>
          {/* <Modal.Description> */}
          <Formiker>
              <div className="ui form">
                <FormUi.Field>
                  <label className="labelName">{t("checkpoint_table_header.checkpoint_name") || "Checkpoint Name"}</label>
                  <Fieldmik component={MyCheckpoint} name="checkPointId" />
                </FormUi.Field>
              </div>
            </Formiker>
          {/* </Modal.Description> */}
        </Modal.Content>
        <Modal.Actions>
        <Button size="mini" type="button" onClick={onClose}>
        {t("checkpoint_action_button.cancel") || "Cancel"}
        </Button>
        <Button size="mini" primary onClick={handleSubmit}>
        {t("checkpoint_action_button.save") || "Save"}
        </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};
const FormikModalEditRouteCheckpoint = withFormik({
  mapPropsToValues(props) {
    return {
        checkPointId: "",
    };
  },
//   validationSchema: yup.object({
//     vendor_id: yup.number().required("required"),
//     driver_name: yup.string().nullable().required("required"),
//   }),
  handleSubmit(values, { setSubmitting, props, resetForm }) {
    let payload = { "checkPointId": values.checkPointId, "routeMasterId": props.route_details}
    console.log('props', props, payload);
    UpdateAxios({ patchURL: `${process.env.REACT_APP_MASTER_API}/updateRouteCheckpoint/${props.addAfter.routeManId}`, payload })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        };
        props.successAlert(alert);
        props.onClose();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: err.response.data.message,
        };
        props.errorAlert(alert);
      });
  },
})(ModalEditRouteCheckpoint);

const mapDispatchToProps = (dispatch) => {
    return {
      successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
      errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
    };
  };

export default connect(null, mapDispatchToProps)(translate("route")(FormikModalEditRouteCheckpoint));
